import { Component } from '@angular/core';
import {DashboardAdvogado} from "../../../../modules/home/models/dashboardAdvogado";
import {StatusAtendimento} from "../../../enums/status-atendimento";
import {StatusProcesso} from "../../../enums/status-processo";
import {Token} from "../../../../modules/auth/models/token";
import {AuthService} from "../../../../modules/auth/services/auth-service";
import {DashboardService} from "../../../../modules/gestao/services/dashboard.service";
import {ToastrService} from "ngx-toastr";
import {DatePipe} from "@angular/common";
import {AudienciaService} from "../../../../modules/juridico/services/audiencia-service";
import {forkJoin} from "rxjs";

@Component({
    selector: 'app-dashboard-advogado',
    templateUrl: './dashboard-advogado.component.html',
    styleUrl: './dashboard-advogado.component.css',
    standalone: false
})
export class DashboardAdvogadoComponent {
  dashboard = new DashboardAdvogado();
  token: Token | undefined;
  constructor(private tokenService: AuthService,
              private dashboardService: DashboardService,
              private audienciaService: AudienciaService,
              private toastr: ToastrService) {
    this.token = this.tokenService.AccessToken;
    this.carregarDados();
  }

  private carregarDados() {
    const hoje = new Date();
    const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
    const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, hoje.getDate());

    const formatarData = (data: Date) => {
      const year = data.getFullYear();
      const month = (data.getMonth() + 1).toString().padStart(2, '0');
      const day = data.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    forkJoin({
      dashboard: this.dashboardService.buscarDashboardAdvogado(),
      audiencias: this.audienciaService.buscarPorData(formatarData(primeiroDia), formatarData(ultimoDia))
    }).subscribe({
      next: (response: any) => {
        if (response.dashboard.sucesso) {
          this.dashboard = response.dashboard.dados;
        }

        if (response.audiencias.sucesso) {
          this.dashboard.audiencias = response.audiencias.dados.itens.map((a: any) => {
            return {
              id: a.id,
              caso: a.processoTitulo || `Processo #${a.processoId}`,
              data: a.dataInicio
            };
          });
        }
      },
      error: (err) => {
        console.error('Erro ao carregar dados do dashboard', err);
      }
    });
  }

  formatarDataEntrega(data: any): string {
    const dataString = data.toString();
    if (dataString.startsWith('0001-01-01')) {
      return 'não estipulado';
    }

    const datePipe = new DatePipe('en-US');
    return datePipe.transform(data, 'dd/MM/yyyy') || '';
  }

  obterClasseIconeTarefa(data: any): string {
    const dataString = data.toString();
    if (dataString.startsWith('0001-01-01')) {
      return 'item-icon green-light';
    }

    const dataEntrega = new Date(data);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    if (dataEntrega < hoje) {
      return 'item-icon red-light';
    }

    return 'item-icon green-light';
  }

  obterDescricaoStatus(status: StatusAtendimento): string {
    switch (status) {
      case StatusAtendimento.ContatoInicial: return 'Contato Inicial';
      case StatusAtendimento.Aberto: return 'Aberto';
      case StatusAtendimento.EmAnalise: return 'Em Análise';
      case StatusAtendimento.EmAtendimento: return 'Em Atendimento';
      case StatusAtendimento.AguardandoCliente: return 'Aguardando Cliente';
      case StatusAtendimento.AguardandoAssinatura: return 'Aguardando Assinatura';
      case StatusAtendimento.Fechado: return 'Fechado';
      case StatusAtendimento.Agendado: return 'Agendado';
      case StatusAtendimento.Cancelado: return 'Cancelado';
      default: return 'Desconhecido';
    }
  }

  obterDescricaoStatusProcesso(status: StatusProcesso): string {
    switch (Number(status)) {
      case StatusProcesso.Aberto: return 'Aberto';
      case StatusProcesso.Oficio: return 'Oficio';
      case StatusProcesso.Fechado: return 'Fechado';
      case StatusProcesso.AguardandoSentenca: return 'Aguardando Sentença';
      case StatusProcesso.AguardandoAudiencia: return 'Aguardando Audiência';
      default: return 'Desconhecido';
    }
  }

  removerTagsHtml(texto: string): string {
    if (!texto) return '';
    return texto.replace(/<[^>]*>/g, '');
  }
}
